// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1nsEV{padding:3.0313rem 6rem}@media(min-width:1024px)and (max-width:1439px){._1nsEV{padding-left:3rem;padding-right:3rem}}@media(max-width:1023px){._1nsEV{padding-left:2.5rem;padding-right:2.5rem}}@media(max-width:767px){._1nsEV{padding-left:1rem;padding-right:1rem}}._2ANNp{margin-top:2.5313rem;margin-bottom:1rem;color:#231815}._3cBN9{color:#595757;font-size:18px;font-size:1.125rem;font-weight:400;line-height:29px;line-height:1.8125rem;font-family:var(--base-font)}._3nK7j{margin-top:3rem;margin-bottom:2rem}._1uARQ{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.-_QYU{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.-_QYU path[fill]{fill:#0373f9}", ""]);
// Exports
exports.locals = {
	"root": "_1nsEV",
	"title": "_2ANNp",
	"description": "_3cBN9",
	"courseList": "_3nK7j",
	"footer": "_1uARQ",
	"moreDownIcon": "-_QYU"
};
module.exports = exports;
